module.exports = __webpack_public_path__ + "img/banner.99e76a8e.webp";